import { DisplayComponent } from "scmp-sdk/components/newsletter/newsletter-widget/enums";
import type { ThemeConfig } from "scmp-sdk/components/newsletter/newsletter-widget/types";

export const config: ThemeConfig = {
  defaultDisplayComponent: DisplayComponent.SignUpNewsletter,
  hasResetAfterSuccess: true,
  hasSanitizeSubscribedNewsletter: false,
};
